import axios from 'axios';
import config from './Config.js'

let http = axios.create({
    baseURL: '/api'
});

function apiAxios(method, url, params, response) {
    http({
        // headers: {
        //     'Access-Control-Allow-Origin': '*'
        // },
        method: method,
        url: url,
        timeout: 300000,
        data: method === 'POST' || method === 'PUT' ? params : null,
        params: method === 'GET' || method === 'DELETE' ? params : null,
    }).then(function (res) {
        response(res);
    }).catch(function (err) {
        response(err);
    })
}

function filePost(url, params, response) {
    http({
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        timeout: 300000,
        url: url,
        data: params
    }).then(function (res) {
        response(res);
    }).catch(function (err) {
        response(err);
    })
}

function DownloadFile(url, params, response) {
    http({
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 300000,
        url: url,
        data: params,
        responseType: 'blob'
    }).then(function (res) {
        response(res);
    }).catch(function (err) {
        response(err);
    })
}

export default {
    get: function (url, params, response) {
        return apiAxios('GET', url, params, response)
    },
    post: function (url, params, response) {
        return apiAxios('POST', url, params, response)
    },
    put: function (url, params, response) {
        return apiAxios('PUT', url, params, response)
    },
    delete: function (url, params, response) {
        return apiAxios('DELETE', url, params, response)
    },
    filePost: function (url, params, response) {
        return filePost(url, params, response)
    },
    downloadFile: function(url, params, response) {
        return DownloadFile(url, params, response)
    }
}